import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const resetBtn = this.element;
    const form = resetBtn.form;

    resetBtn.addEventListener('click', () => {
      setTimeout(() => {
        $('.select2-hidden-accessible', form).trigger('change');
        $("input[name=commit]", form).click();

        resetBtn.disabled = true;

        document.addEventListener("turbo:submit-end", function handler(event) {
          if (event.target == form) {
            resetBtn.disabled = false;
            document.removeEventListener("turbo:submit-end", handler);
          }
        });
      }, 0)
    })
  }
}
